import { useSelector } from "react-redux"
import BVerificar from "./BVerficar"
import BAnularVerificacion from "./BAnularVerificacion"
import FCliente from "./FCliente"
import FFechaViaje from "./FFechaViaje"
import FHabitaciones from "./FHabitaciones"
import { Alert } from "@material-ui/lab"
import { Grid, Divider } from "@material-ui/core"
import FMensualidades from "./FMensualidades"
import { esFinalizado } from "../../../utils/esFinalizado"
const EditarDatos = () => {
    const { referencia, cliente } = useSelector(store => store.cliente)
    if (referencia) return (
        <Grid container>
            {
                (!esFinalizado(cliente?.paquete?.CatEstatusProceso?.IdEstatusProceso)) && <Grid item xs={12}>
                    <div style={{ textAlign: "right", margin: "2%" }}>

                        <BVerificar />
                        <BAnularVerificacion />
                    </div>
                </Grid>
            }
            <Grid item xs={12}>
                <div style={{ margin: "0 2%", padding: "0.5rem", borderRight: "1px solid #E3E3E3" }}>
                    <h3>Datos cliente</h3>
                    <FCliente />
                    <Divider style={{ backgroundColor: "rgb(105, 163, 59)", height: "3px" }} />
                </div>
            </Grid>
            <Grid item xs={12}>
                <div style={{ margin: "0 2%", padding: "0.5rem", borderLeft: "1px solid #E3E3E3" }}>
                    <h3>Fecha de salida</h3>
                    <FFechaViaje />
                    <Divider style={{ backgroundColor: "rgb(105, 163, 59)", height: "3px" }} />
                </div>
            </Grid>
            <Grid item xs={12}>
                <div style={{ margin: "0 2%", padding: "0.5rem", borderLeft: "1px solid #E3E3E3" }}>
                    <h3>Numero de mensualidades</h3>
                    <FMensualidades />
                    <Divider style={{ backgroundColor: "rgb(105, 163, 59)", height: "3px" }} />
                </div>
            </Grid>
            <Grid item xs={12}>
                <div style={{ margin: "0 2%", padding: "0.5rem", borderLeft: "1px solid #E3E3E3" }}>
                    <h3>Habitaciones</h3>
                    <FHabitaciones />
                </div>
            </Grid>
        </Grid>
    )
    return (
        <Alert className="alerta" severity="info">Seleccione un cliente</Alert>
    )
}
export default EditarDatos